export default __webpack_public_path__ + "static/media/google.b22b8a66.png";